<template>
  <div>
    taxonomyName
  </div>
</template>

<script>
export default {
    name:'taxonomyName'
}
</script>

<style>

</style>